// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container structure - from EventPage.css */
.locationpage-wrapper {
    display: flex;
    min-height: 100vh;
    background: var(--card-bg, rgb(4, 4, 4));
    overflow: hidden; /* Prlocation wrapper from scrolling */
  }
  
  .locationpage-content {
    margin-left: 80px;
    flex: 1 1;
    padding: 20px;
    height: 100vh; /* Fixed height */
    overflow-y: auto; /* Enable vertical scrolling */
    overflow-x: hidden; /* Prlocation horizontal scrolling */
  }
  
  /* Event Grid Layout CSS */
  
  /* Remove the duplicate/conflicting definition */
  /* DELETE THIS - it's causing the scroll issue:
  .ep-grid-layout {
      position: absolute;  <- This is the problem!
      min-height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-left: 0px;
  }
  */
  
  .ep-text-label {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-size: 20px;
      margin-top: 20px;
      font-weight: 700; /* Changed from "bold" string to numeric value */
  }
  
  /* Event Info Header */
  .ep-location-info {
      background: none;
      padding: 24px 32px;
      border-radius: 16px;
      margin-bottom: 32px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      color: white;
  }
  
  .ep-location-type {
      font-size: 24px;
      font-weight: 700;
      color: white;
      margin: 0 0 12px 0;
  }
  
  .ep-location-date {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      color: white;
      margin: 0;
  }
  
  /* Grid Container */
  .ep-grid-container {
      width: 100%;
      /* Remove any position: absolute or fixed here */
  }
  
  /* Main Grid Layout - CORRECTED VERSION */
  .ep-grid-layout {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 24px;
      padding-bottom: 40px;
      width: 100%;
      /* Removed position: absolute */
      /* Removed min-height: 100% */
      /* These were prlocationing proper scrolling */
  }
  
  /* Image Card */
  .ep-image-card {
      background: white;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease;
      cursor: pointer;
      display: flex;
      flex-direction: column;
  }
  
  .ep-image-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
  
  .ep-image-container {
      width: 100%;
      height: 280px;
      overflow: hidden;
      background: #f0f0f0;
  }
  
  .ep-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
  }
  
  .ep-image-card:hover .ep-image {
      transform: scale(1.05);
  }
  
  /* Card Info */
  .ep-card-info {
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 12px;
  }
  
  .ep-user-info {
      display: flex;
      align-items: center;
      gap: 12px;
  }
  
  .ep-user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #007BFF;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      overflow: hidden;
      flex-shrink: 0; /* Prlocation avatar from shrinking */
  }
  
  .ep-user-avatar img {
      width: 100%;
      height: 100%;
      object-fit: cover;
  }
  
  .ep-user-details {
      flex: 1 1;
      min-width: 0; /* Allow text to truncate properly */
  }
  
  .ep-username {
      font-size: 15px;
      font-weight: 600;
      color: #2c2c2c;
      margin: 0 0 4px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
  
  .ep-post-time {
      font-size: 12px;
      color: #888;
      margin: 0;
  }
  
  .ep-card-meta {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;
  }
  
  .ep-meta-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      color: #666;
  }
  
  .ep-meta-item svg {
      color: #007BFF;
      flex-shrink: 0;
  }
  
  /* No Content Message */
  .no-content-message {
      text-align: center;
      color: #666;
      font-size: 18px;
      padding: 60px 20px;
      grid-column: 1 / -1;
  }
  
  .error-message {
      text-align: center;
      color: #ff4d4d;
      font-size: 18px;
      padding: 60px 20px;
  }
  
  /* Loading State */
  .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 60vh;
      gap: 20px;
  }
  
  .loading-spinner {
      width: 50px;
      height: 50px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #007BFF;
      border-radius: 50%;
      animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
  }
  
  /* Smooth scrolling */
  .locationpage-content::-webkit-scrollbar {
      width: 8px;
  }
  
  .locationpage-content::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
  }
  
  .locationpage-content::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
  }
  
  .locationpage-content::-webkit-scrollbar-thumb:hover {
      background: #555;
  }
  
  /* Responsive */
  @media (max-width: 768px) {
      .locationpage-content {
          margin-left: 60px; /* Adjust for smaller sidebar */
          padding: 16px;
      }
  
      .ep-grid-layout {
          grid-template-columns: 1fr;
          gap: 16px;
      }
  
      .ep-image-container {
          height: 240px;
      }
  
      .ep-location-info {
          padding: 16px 20px;
      }
  }
  
  @media (max-width: 480px) {
      .ep-grid-layout {
          gap: 12px;
      }
  
      .ep-image-container {
          height: 200px;
      }
  }
  
  /* ============================================ */
/*  PAGE WRAPPER — left rail + main content     */
/* ============================================ */
.ep-page-wrapper {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;
    align-items: flex-start;
  }
  
  /* ---------- Left rail: quick-link buttons ---------- */
  .ep-quick-links {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: sticky;
    top: 16px;
    z-index: 5;
  }
  
  .ep-quick-link-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 140px;
    padding: 10px 8px 12px;
    border-radius: 14px;
    background: rgba(36, 36, 45, 0.55);
    border: 1px solid rgba(168, 139, 250, 0.18);
    text-decoration: none;
    color: white;
    cursor: pointer;
    transition: transform 0.2s ease, border-color 0.2s ease,
                box-shadow 0.2s ease, background 0.2s ease;
    overflow: hidden;
  }
  
  .ep-quick-link-btn:hover {
    transform: translateY(-3px);
    border-color: rgba(168, 139, 250, 0.5);
    background: rgba(124, 58, 237, 0.12);
    box-shadow: 0 8px 24px rgba(124, 58, 237, 0.25);
  }
  
  .ep-quick-link-btn:active {
    transform: translateY(-1px);
  }
  
  .ep-quick-link-img {
    width: 100%;
    height: 84px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 8px;
    background: rgba(255, 255, 255, 0.04);
  }
  
  .ep-quick-link-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-align: center;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.3;
  }
  
  /* ---------- Main content takes the rest ---------- */
  .ep-page-wrapper > .ep-grid-container {
    flex: 1 1 auto;
    min-width: 0;
  }
  
  /* ---------- Responsive: collapse rail on small screens ---------- */
  @media (max-width: 720px) {
    .ep-page-wrapper {
      flex-direction: column;
      gap: 12px;
    }
  
    .ep-quick-links {
      position: static;
      flex-direction: row;
      overflow-x: auto;
      width: 100%;
      padding-bottom: 4px;
      scrollbar-width: thin;
    }
  
    .ep-quick-link-btn {
      flex: 0 0 auto;
      width: 120px;
    }
  }
  
  @media (max-width: 420px) {
    .ep-quick-link-btn {
      width: 100px;
      padding: 8px 6px 10px;
    }
  
    .ep-quick-link-img {
      height: 64px;
    }
  
    .ep-quick-link-label {
      font-size: 10px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/LocationPage/Styles/LocationGridLayout.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;IACI,aAAa;IACb,iBAAiB;IACjB,wCAAwC;IACxC,gBAAgB,EAAE,sCAAsC;EAC1D;;EAEA;IACE,iBAAiB;IACjB,SAAO;IACP,aAAa;IACb,aAAa,EAAE,iBAAiB;IAChC,gBAAgB,EAAE,8BAA8B;IAChD,kBAAkB,EAAE,oCAAoC;EAC1D;;EAEA,0BAA0B;;EAE1B,gDAAgD;EAChD;;;;;;;;;GASC;;EAED;MACI,4DAA4D;MAC5D,eAAe;MACf,gBAAgB;MAChB,gBAAgB,EAAE,gDAAgD;EACtE;;EAEA,sBAAsB;EACtB;MACI,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;MACnB,yCAAyC;MACzC,YAAY;EAChB;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;EACtB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,eAAe;MACf,YAAY;MACZ,SAAS;EACb;;EAEA,mBAAmB;EACnB;MACI,WAAW;MACX,gDAAgD;EACpD;;EAEA,yCAAyC;EACzC;MACI,aAAa;MACb,4DAA4D;MAC5D,SAAS;MACT,oBAAoB;MACpB,WAAW;MACX,+BAA+B;MAC/B,6BAA6B;MAC7B,8CAA8C;EAClD;;EAEA,eAAe;EACf;MACI,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB;MAChB,0CAA0C;MAC1C,yBAAyB;MACzB,eAAe;MACf,aAAa;MACb,sBAAsB;EAC1B;;EAEA;MACI,2BAA2B;MAC3B,0CAA0C;EAC9C;;EAEA;MACI,WAAW;MACX,aAAa;MACb,gBAAgB;MAChB,mBAAmB;EACvB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,+BAA+B;EACnC;;EAEA;MACI,sBAAsB;EAC1B;;EAEA,cAAc;EACd;MACI,aAAa;MACb,aAAa;MACb,sBAAsB;MACtB,SAAS;EACb;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,SAAS;EACb;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;MACZ,gBAAgB;MAChB,cAAc,EAAE,qCAAqC;EACzD;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,iBAAiB;EACrB;;EAEA;MACI,SAAO;MACP,YAAY,EAAE,oCAAoC;EACtD;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;EACvB;;EAEA;MACI,eAAe;MACf,WAAW;MACX,SAAS;EACb;;EAEA;MACI,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,iBAAiB;MACjB,6BAA6B;EACjC;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,eAAe;MACf,WAAW;EACf;;EAEA;MACI,cAAc;MACd,cAAc;EAClB;;EAEA,uBAAuB;EACvB;MACI,kBAAkB;MAClB,WAAW;MACX,eAAe;MACf,kBAAkB;MAClB,mBAAmB;EACvB;;EAEA;MACI,kBAAkB;MAClB,cAAc;MACd,eAAe;MACf,kBAAkB;EACtB;;EAEA,kBAAkB;EAClB;MACI,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;MACZ,SAAS;EACb;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,6BAA6B;MAC7B,kBAAkB;MAClB,kCAAkC;EACtC;;EAEA;MACI,KAAK,uBAAuB,EAAE;MAC9B,OAAO,yBAAyB,EAAE;EACtC;;EAEA,qBAAqB;EACrB;MACI,UAAU;EACd;;EAEA;MACI,mBAAmB;MACnB,mBAAmB;EACvB;;EAEA;MACI,gBAAgB;MAChB,mBAAmB;EACvB;;EAEA;MACI,gBAAgB;EACpB;;EAEA,eAAe;EACf;MACI;UACI,iBAAiB,EAAE,+BAA+B;UAClD,aAAa;MACjB;;MAEA;UACI,0BAA0B;UAC1B,SAAS;MACb;;MAEA;UACI,aAAa;MACjB;;MAEA;UACI,kBAAkB;MACtB;EACJ;;EAEA;MACI;UACI,SAAS;MACb;;MAEA;UACI,aAAa;MACjB;EACJ;;EAEA,iDAAiD;AACnD,iDAAiD;AACjD,iDAAiD;AACjD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;;EAEA,wDAAwD;EACxD;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kCAAkC;IAClC,2CAA2C;IAC3C,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf;0DACsD;IACtD,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,sCAAsC;IACtC,oCAAoC;IACpC,+CAA+C;EACjD;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA,sDAAsD;EACtD;IACE,cAAc;IACd,YAAY;EACd;;EAEA,qEAAqE;EACrE;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;MAChB,WAAW;MACX,mBAAmB;MACnB,qBAAqB;IACvB;;IAEA;MACE,cAAc;MACd,YAAY;IACd;EACF;;EAEA;IACE;MACE,YAAY;MACZ,qBAAqB;IACvB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["/* Main container structure - from EventPage.css */\n.locationpage-wrapper {\n    display: flex;\n    min-height: 100vh;\n    background: var(--card-bg, rgb(4, 4, 4));\n    overflow: hidden; /* Prlocation wrapper from scrolling */\n  }\n  \n  .locationpage-content {\n    margin-left: 80px;\n    flex: 1;\n    padding: 20px;\n    height: 100vh; /* Fixed height */\n    overflow-y: auto; /* Enable vertical scrolling */\n    overflow-x: hidden; /* Prlocation horizontal scrolling */\n  }\n  \n  /* Event Grid Layout CSS */\n  \n  /* Remove the duplicate/conflicting definition */\n  /* DELETE THIS - it's causing the scroll issue:\n  .ep-grid-layout {\n      position: absolute;  <- This is the problem!\n      min-height: 100%;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      margin-left: 0px;\n  }\n  */\n  \n  .ep-text-label {\n      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n      font-size: 20px;\n      margin-top: 20px;\n      font-weight: 700; /* Changed from \"bold\" string to numeric value */\n  }\n  \n  /* Event Info Header */\n  .ep-location-info {\n      background: none;\n      padding: 24px 32px;\n      border-radius: 16px;\n      margin-bottom: 32px;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n      color: white;\n  }\n  \n  .ep-location-type {\n      font-size: 24px;\n      font-weight: 700;\n      color: white;\n      margin: 0 0 12px 0;\n  }\n  \n  .ep-location-date {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-size: 16px;\n      color: white;\n      margin: 0;\n  }\n  \n  /* Grid Container */\n  .ep-grid-container {\n      width: 100%;\n      /* Remove any position: absolute or fixed here */\n  }\n  \n  /* Main Grid Layout - CORRECTED VERSION */\n  .ep-grid-layout {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n      gap: 24px;\n      padding-bottom: 40px;\n      width: 100%;\n      /* Removed position: absolute */\n      /* Removed min-height: 100% */\n      /* These were prlocationing proper scrolling */\n  }\n  \n  /* Image Card */\n  .ep-image-card {\n      background: white;\n      border-radius: 16px;\n      overflow: hidden;\n      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n      transition: all 0.3s ease;\n      cursor: pointer;\n      display: flex;\n      flex-direction: column;\n  }\n  \n  .ep-image-card:hover {\n      transform: translateY(-8px);\n      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  }\n  \n  .ep-image-container {\n      width: 100%;\n      height: 280px;\n      overflow: hidden;\n      background: #f0f0f0;\n  }\n  \n  .ep-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      transition: transform 0.3s ease;\n  }\n  \n  .ep-image-card:hover .ep-image {\n      transform: scale(1.05);\n  }\n  \n  /* Card Info */\n  .ep-card-info {\n      padding: 16px;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n  }\n  \n  .ep-user-info {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n  }\n  \n  .ep-user-avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      background: #007BFF;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      overflow: hidden;\n      flex-shrink: 0; /* Prlocation avatar from shrinking */\n  }\n  \n  .ep-user-avatar img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n  }\n  \n  .ep-user-details {\n      flex: 1;\n      min-width: 0; /* Allow text to truncate properly */\n  }\n  \n  .ep-username {\n      font-size: 15px;\n      font-weight: 600;\n      color: #2c2c2c;\n      margin: 0 0 4px 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n  }\n  \n  .ep-post-time {\n      font-size: 12px;\n      color: #888;\n      margin: 0;\n  }\n  \n  .ep-card-meta {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding-top: 12px;\n      border-top: 1px solid #f0f0f0;\n  }\n  \n  .ep-meta-item {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 13px;\n      color: #666;\n  }\n  \n  .ep-meta-item svg {\n      color: #007BFF;\n      flex-shrink: 0;\n  }\n  \n  /* No Content Message */\n  .no-content-message {\n      text-align: center;\n      color: #666;\n      font-size: 18px;\n      padding: 60px 20px;\n      grid-column: 1 / -1;\n  }\n  \n  .error-message {\n      text-align: center;\n      color: #ff4d4d;\n      font-size: 18px;\n      padding: 60px 20px;\n  }\n  \n  /* Loading State */\n  .loading-container {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      height: 60vh;\n      gap: 20px;\n  }\n  \n  .loading-spinner {\n      width: 50px;\n      height: 50px;\n      border: 4px solid #f3f3f3;\n      border-top: 4px solid #007BFF;\n      border-radius: 50%;\n      animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n      0% { transform: rotate(0deg); }\n      100% { transform: rotate(360deg); }\n  }\n  \n  /* Smooth scrolling */\n  .locationpage-content::-webkit-scrollbar {\n      width: 8px;\n  }\n  \n  .locationpage-content::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 10px;\n  }\n  \n  .locationpage-content::-webkit-scrollbar-thumb {\n      background: #888;\n      border-radius: 10px;\n  }\n  \n  .locationpage-content::-webkit-scrollbar-thumb:hover {\n      background: #555;\n  }\n  \n  /* Responsive */\n  @media (max-width: 768px) {\n      .locationpage-content {\n          margin-left: 60px; /* Adjust for smaller sidebar */\n          padding: 16px;\n      }\n  \n      .ep-grid-layout {\n          grid-template-columns: 1fr;\n          gap: 16px;\n      }\n  \n      .ep-image-container {\n          height: 240px;\n      }\n  \n      .ep-location-info {\n          padding: 16px 20px;\n      }\n  }\n  \n  @media (max-width: 480px) {\n      .ep-grid-layout {\n          gap: 12px;\n      }\n  \n      .ep-image-container {\n          height: 200px;\n      }\n  }\n  \n  /* ============================================ */\n/*  PAGE WRAPPER — left rail + main content     */\n/* ============================================ */\n.ep-page-wrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    width: 100%;\n    align-items: flex-start;\n  }\n  \n  /* ---------- Left rail: quick-link buttons ---------- */\n  .ep-quick-links {\n    flex: 0 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    position: sticky;\n    top: 16px;\n    z-index: 5;\n  }\n  \n  .ep-quick-link-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 140px;\n    padding: 10px 8px 12px;\n    border-radius: 14px;\n    background: rgba(36, 36, 45, 0.55);\n    border: 1px solid rgba(168, 139, 250, 0.18);\n    text-decoration: none;\n    color: white;\n    cursor: pointer;\n    transition: transform 0.2s ease, border-color 0.2s ease,\n                box-shadow 0.2s ease, background 0.2s ease;\n    overflow: hidden;\n  }\n  \n  .ep-quick-link-btn:hover {\n    transform: translateY(-3px);\n    border-color: rgba(168, 139, 250, 0.5);\n    background: rgba(124, 58, 237, 0.12);\n    box-shadow: 0 8px 24px rgba(124, 58, 237, 0.25);\n  }\n  \n  .ep-quick-link-btn:active {\n    transform: translateY(-1px);\n  }\n  \n  .ep-quick-link-img {\n    width: 100%;\n    height: 84px;\n    object-fit: cover;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    background: rgba(255, 255, 255, 0.04);\n  }\n  \n  .ep-quick-link-label {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-align: center;\n    color: rgba(255, 255, 255, 0.9);\n    line-height: 1.3;\n  }\n  \n  /* ---------- Main content takes the rest ---------- */\n  .ep-page-wrapper > .ep-grid-container {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n  \n  /* ---------- Responsive: collapse rail on small screens ---------- */\n  @media (max-width: 720px) {\n    .ep-page-wrapper {\n      flex-direction: column;\n      gap: 12px;\n    }\n  \n    .ep-quick-links {\n      position: static;\n      flex-direction: row;\n      overflow-x: auto;\n      width: 100%;\n      padding-bottom: 4px;\n      scrollbar-width: thin;\n    }\n  \n    .ep-quick-link-btn {\n      flex: 0 0 auto;\n      width: 120px;\n    }\n  }\n  \n  @media (max-width: 420px) {\n    .ep-quick-link-btn {\n      width: 100px;\n      padding: 8px 6px 10px;\n    }\n  \n    .ep-quick-link-img {\n      height: 64px;\n    }\n  \n    .ep-quick-link-label {\n      font-size: 10px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
